var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 6C5.16421 6 5.5 6.33579 5.5 6.75V17.25C5.5 17.9404 6.05964 18.5 6.75 18.5H19.5C19.9142 18.5 20.25 18.8358 20.25 19.25C20.25 19.6642 19.9142 20 19.5 20H6.75C5.23122 20 4 18.7688 4 17.25V6.75C4 6.33579 4.33579 6 4.75 6ZM17.6893 7.75L13.5811 11.8582L12.6 10.55C12.4695 10.3761 12.27 10.2673 12.0532 10.2519C11.8363 10.2365 11.6234 10.3159 11.4697 10.4697L6.96967 14.9697C6.67678 15.2626 6.67678 15.7374 6.96967 16.0303C7.26256 16.3232 7.73744 16.3232 8.03033 16.0303L11.9189 12.1418L12.9 13.45C13.0305 13.6239 13.23 13.7327 13.4468 13.7481C13.6637 13.7635 13.8766 13.6841 14.0303 13.5303L18.75 8.81066V10.5C18.75 10.9142 19.0858 11.25 19.5 11.25C19.9142 11.25 20.25 10.9142 20.25 10.5V7C20.25 6.58579 19.9142 6.25 19.5 6.25H16C15.5858 6.25 15.25 6.58579 15.25 7C15.25 7.41421 15.5858 7.75 16 7.75H17.6893Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/Analysis.cd125565c49d01f41680b04ddba92e10.svg";
export { ForwardRef as ReactComponent };